import React, { useState } from "react";
import Layout from "../../component/Layout";
import { Header } from "../../component/Header";
import cardbg from "../../images/cardbg.png";
const Dashboard = () => {
  const [selectedStat, setSelectedStat] = useState("Stat A");
  return (
    <Layout>
      <div className="bg-white">
        <Header />
      </div>
      <div className="bg-white">
        <h3 className="text-black text-[28px] font-normal pb-5 w-full max-w-2xl mx-auto px-[15px]">
          Good morning, Jason
        </h3>
      </div>
      <div className="w-full max-w-2xl mx-auto h-inherit">
        <div className="p-[29px_20px_18px] relative bg-black h-full dashboardbg">
          <div className="flex flex-col gap-3">
            <div className="rounded-[20px] overflow-hidden p-[15px] cardbg">
              <p className="text-white text-xl font-normal mb-[75px]">
                You have a workout today
              </p>
              <p className="text-white text-[13px] font-semibold">
                180 jump squats <br />
                <span className="font-light">
                  6 legs • Endurance <br /> 52 min • 255 cal
                </span>
              </p>
            </div>

            {/* make selecteable here */}
            <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 flex justify-center items-center gap-10 pb-5">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="stats"
                  value="Stat A"
                  checked={selectedStat === "Stat A"}
                  onChange={() => setSelectedStat("Stat A")}
                  className="hidden"
                />
                <span
                  className={`w-3 h-3 rounded-full ${
                    selectedStat === "Stat A" ? "bg-[#ECECEC]" : "bg-[#6E6E6E] "
                  }`}
                ></span>
                <span className="text-white text-sm whitespace-nowrap font-normal">
                  Stat A
                </span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="stats"
                  value="Stat B"
                  checked={selectedStat === "Stat B"}
                  onChange={() => setSelectedStat("Stat B")}
                  className="hidden"
                />
                <span
                  className={`w-3 h-3 rounded-full ${
                    selectedStat === "Stat B" ? "bg-[#ECECEC]" : "bg-[#6E6E6E] "
                  }`}
                ></span>
                <span className="text-white text-sm whitespace-nowrap font-normal">
                  Stat B
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
